"use client";
import { useCartStore } from "@/providers/cart-store-provider";
import { env } from "@/types/env";
import { MinusIcon, PlusIcon } from "lucide-react";

const QtyButtons = ({
  id,
  quantity,
  available_quantity,
}: {
  id: number;
  quantity: number;
  available_quantity?: number;
}) => {
  const incrementQuantity = useCartStore((state) => state.incrementQuantity);
  const decrementQuantity = useCartStore((state) => state.decrementQuantity);
  if (id === env.NEXT_PUBLIC_COUPON_ID) {
    return null;
  }
  return (
    <div className="flex w-[90px] items-center">
      <button className="px-2 " onClick={() => decrementQuantity(id, 1)}>
        <MinusIcon className="size-4" />
      </button>
      <span className=" border size-8 flex justify-center items-center">
        {quantity}
      </span>
      <button
        disabled={
          available_quantity !== undefined && quantity >= available_quantity
        }
        className="px-2 "
        onClick={() => incrementQuantity(id, 1)}
      >
        <PlusIcon className="size-4" />
      </button>
    </div>
  );
};

export default QtyButtons;
